import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SinalizationService } from '@services/sinalization.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '@store/state/app.state';
import { GetSinalization } from '@store/actions/user.action';
import { MessageService } from '@services/message.service';
import { Router } from '@angular/router';
import { getMaturity } from '@store/selectors/config.selector';
import { take, finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-fast-quote-pending',
    templateUrl: './fast-quote-pending.component.html',
    styleUrls: ['./fast-quote-pending.component.scss'],
    standalone: false
})
export class FastQuotePendingComponent implements OnInit {

  fastQuoteTargetForm: UntypedFormGroup;
  sent = false;
  submit = false;
  confirmed = false;
  error = false;
  // True while the request is running: avoids sending the signalization more than once
  pending = false;
  numberOnly = '^[0-9]*$';

  maturityValues = [];
  percentageValues = [25, 50, 75, 100];

  constructor(private readonly formBuilder: UntypedFormBuilder,
              private readonly sinalizationService: SinalizationService,
              private readonly messageService: MessageService,
              private readonly router: Router,
              public store: Store<AppState>,
              private readonly translateService: TranslateService) { }

  ngOnInit() {

    this.store.pipe(
      select(getMaturity),
      take(1)
    ).subscribe(maturities => this.maturityValues = maturities.map(maturity => maturity.maturity));

    this.fastQuoteTargetForm = this.formBuilder.group({
      maturity: ['', Validators.required],
      value: ['', Validators.required],
      price: ['', [Validators.required, Validators.pattern(this.numberOnly)]]
    });
  }

  get f() { return this.fastQuoteTargetForm.controls; }

  onSubmit() {
    this.sent = true;
    if (this.fastQuoteTargetForm.invalid) {
        return;
    }
    this.submit = true;
  }

  confirm(): void {
    if (this.pending) {
      return;
    }

    const args = {
      mns: 'fastQuoteOTCPT',
      mtv: this.fastQuoteTargetForm.value.value,
      mmt: this.fastQuoteTargetForm.value.maturity,
      mcv: this.fastQuoteTargetForm.value.price
    };

    this.pending = true;
    this.sinalizationService.createSinalization(args).pipe(
      finalize(() => this.pending = false)
    ).subscribe((response) => {
      if (response.status === 200 && response.success) {
        this.store.dispatch(new GetSinalization());
        this.messageService.show(this.translateService.instant('edp.emarket.fast.quote.sinalizacao.enviada'));
        this.router.navigate(['/signalings']);
      } else {
        this.messageService.show(this.translateService.instant('edp.emarket.fast.quote.erro.enviar'), 'error');
      }
    });
  }

}
